import type { CustomerFeeLineV2 } from "@credit-acceptance/step6-bff-client";
import { useTranslation } from "react-i18next";

import { formatCurrency } from "../../../../lib/money";
import type { AuditTableColumn } from "../../../audit/AuditTable";
import SummaryTableModal from "../../components/SummaryTableModal";
import { EMPTY_VALUE, formatOptional } from "./financialFormat";

interface CustomerFeesModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fees: CustomerFeeLineV2[];
  total?: number;
}

// Read-only actual/RISC/correction amounts per customer fee, opened from the "Total Customer Fees" link
function CustomerFeesModal({ open, onOpenChange, fees, total }: CustomerFeesModalProperties) {
  const { t } = useTranslation();

  const columns: Array<AuditTableColumn<CustomerFeeLineV2>> = [
    { key: "name", header: t("financial.modalColumns.name"), render: (fee) => fee.name || EMPTY_VALUE },
    {
      key: "actualAmount",
      header: t("financial.modalColumns.actualAmount"),
      render: (fee) => formatOptional(fee.actualAmount, formatCurrency),
    },
    {
      key: "riscAmount",
      header: t("financial.modalColumns.riscAmount"),
      render: (fee) => formatOptional(fee.riscAmount, formatCurrency),
    },
    {
      key: "correctionAmount",
      header: t("financial.modalColumns.correctionAmount"),
      render: (fee) => formatOptional(fee.correctionAmount, formatCurrency),
    },
  ];

  return (
    <SummaryTableModal
      open={open}
      onOpenChange={onOpenChange}
      title={t("financial.customerFeesModal.title")}
      description={t("financial.customerFeesModal.description")}
      caption={t("financial.customerFeesModal.caption")}
      summaryLines={[{ label: t("financial.customerFeesModal.total"), value: formatOptional(total, formatCurrency) }]}
      columns={columns}
      rows={fees}
    />
  );
}

export default CustomerFeesModal;
